/**
 * This page is to set configurations and targets against to BUs. i.e add, edit etc
 * this page respective report is still pending, we have shared doubts and clarifications, based on that some changes 
 * needed here.
 */
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GetRoles } from 'src/app/actions/roleManagement.action';
import { ReportsService } from '../../services/reports.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { MessageServiceService } from '../../services/message-service.service'
import { CommonMethods } from '../../shared/CommonMethods';
import { Constants } from './../../app.constants';
import { UserprivilegeService } from './../../services/userprivilege.service';
import { ExportOptions } from 'src/app/models/common-model';
import { CommonService } from 'src/app/services/common.service';
import { PostSetTargets, SetTargets } from 'src/app/models/reports.model';
@Component({
  selector: 'app-set-targets',
  templateUrl: './set-targets.component.html',
  styleUrls: ['./set-targets.component.scss']
})
export class SetTargetsComponent implements OnInit {
  isSubmitted = false
  confirmModalRef: BsModalRef;
  @ViewChild('confirmTemplate', { static: false }) confirmTemplate: TemplateRef<any>;
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  }
  columns: any[];
  activeOptions: any[];
  isUpdateFlag: Boolean = false;
  targetsData: SetTargets[];
  addForm: FormGroup;
  dateConfig: Partial<BsDatepickerConfig>;  
  targetMinDate: Date
  targetMaxDate: Date
  postTargetData: PostSetTargets ;
  constructor(
    private fb: FormBuilder,
    private store: Store,
    private modalService: BsModalService,
    private messageService: MessageServiceService,
    private userPrivilegesService: UserprivilegeService,
    private reportsSerive: ReportsService,
    private commonService: CommonService
  ) {
    
    this.dateConfig = Object.assign({}, { containerClass: 'theme-orange', dateInputFormat: 'DD/MM/YYYY' });
    this.columns = [
      { field: 'clinicTypeName', header: 'Business Unit', width: '15%' },
      { field: 'expectedLeads', header: 'Expected Leads', width: '15%' },
      { field: 'expectedRevenue', header: 'Expected Revenue', width: '15%' },
      { field: 'fromDate', header: 'From Date', width: '15%' },
      { field: 'toDate', header: 'To Date', width: '15%' },      
      { field: 'createdOn', header: 'Created On', width: '15%' },
      { field: 'isActive', header: 'Target Status', width: '15%' },
      // { field: 'actions', header: 'Actions',width: '30%' },
    ];

    this.activeOptions = [
      { label: 'All', value: null },
      { label: 'Activated', value: '1' },
      { label: 'Deactivated', value: '0' }
    ];
  }
  //Privilege flags
  hasAddEditPrivilege: Boolean = false;
  hasActivateDeactivatePrivilege: Boolean = false;
  hasExportPrivilege: Boolean = false;
  ngOnInit() {
    this.getAllTargetsList();
    this.getBussinessUnits();
    this.createForm();
    //this.targetMinDate = new Date(); 
    setTimeout(() => {

      if (this.userPrivilegesService.hasAddEditPrivilege(Constants.ManageRoleScreen)) {
        this.hasAddEditPrivilege = true;
      }
      if (this.userPrivilegesService.hasActivateDeActivatePrivilege(Constants.ManageRoleScreen)) {
        this.hasActivateDeactivatePrivilege = true;
      }
      if (this.userPrivilegesService.hasExportPrivilege(Constants.ManageRoleScreen)) {
        this.hasExportPrivilege = true;
      }

    }, 500);
  }

  createForm() {
    this.addForm = this.fb.group({      
      clinicType: ['',[Validators.required]],
      expectedRevenue: ['',[Validators.required]],
      expectedLeads: ['',[Validators.required]],      
      fromDate: ['',[Validators.required]],
      toDate: ['',[Validators.required]],      
    })
  }

  totalRecords: number = 0;
  getAllTargetsList() {
    this.isSubmitted = true
    this.reportsSerive.getAllTargetedList()
      .subscribe((res: any) => {
        if (res.response.length > 0) {
          this.targetsData = res.response;
          console.log(this.targetsData)          
        }
        this.isSubmitted = false
      }, error => {
        this.isSubmitted = false
        this.messageService.showErrorMessage("Unable to retrieve BU targets data from server ");
      })
  }

  
  modalTitle: string = "Add Target";
  currentSelectedTarget:SetTargets =<SetTargets> {};
  editTarget(payload) {    
    this.currentSelectedTarget = <SetTargets> {};
    this.currentSelectedTarget = payload;    
    this.modalTitle = "Update Target";
    this.confirmModalRef = this.modalService.show(this.confirmTemplate, Object.assign({}, this.config, { class: 'gray modal-md modal-dialog-centered' }));
    this.isUpdateFlag = true;
    this.addForm.get('clinicType').setValue(this.currentSelectedTarget.clinicType);
      this.addForm.get('expectedLeads').setValue(this.currentSelectedTarget.expectedLeads);
      this.addForm.get('expectedRevenue').setValue(this.currentSelectedTarget.expectedRevenue);
      this.addForm.get('fromDate').setValue(this.changeDateFormat(this.currentSelectedTarget.fromDate));
      this.addForm.get('toDate').setValue(this.changeDateFormat(this.currentSelectedTarget.toDate));
  }

  changeDateFormat(d){
    let a = d.split(' '); //a[1] = time
    let aa = a[0].split('-');
    return new Date(aa[2]+"/"+aa[1]+"/"+aa[0]+" "+ a[1]);
  }

  addRoleModal() {
    this.modalTitle = "Add Target";
    this.confirmModalRef = this.modalService.show(this.confirmTemplate, Object.assign({}, this.config, { class: 'gray modal-md modal-dialog-centered' }));
    this.isUpdateFlag = false;
    this.currentSelectedTarget = <SetTargets> {};
    this.clearForm();
  }

  clearForm() {    
    if (this.isUpdateFlag) {
      this.addForm.get('clinicType').setValue(this.currentSelectedTarget.clinicType);
      this.addForm.get('expectedLeads').setValue(this.currentSelectedTarget.expectedLeads);
      this.addForm.get('expectedRevenue').setValue(this.currentSelectedTarget.expectedRevenue);
      this.addForm.get('fromDate').setValue(this.changeDateFormat(this.currentSelectedTarget.fromDate));
      this.addForm.get('toDate').setValue(this.changeDateFormat(this.currentSelectedTarget.toDate));
    }
    else {
      this.addForm.reset();
      this.addForm.get('clinicType').setValue('');
      this.isUpdateFlag = false;
    }
  }

  onSubmit(formData) {
    this.isSubmitted = true
    const controls = this.addForm.controls;
    /** check form */
    if (this.addForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }

    if (new Date(formData.toDate) < new Date(formData.fromDate) ) {
      this.messageService.showErrorMessage("To Date must be greater than From Date");
      this.isSubmitted = false;
      return;
    }

    this.postTargetData = {
      clinicType: +formData.clinicType,
      expectedLeads: +formData.expectedLeads,
      expectedRevenue: +formData.expectedRevenue,
      fromDate: new Date(formData.fromDate),
      toDate: new Date(formData.toDate),
      operation: this.isUpdateFlag ? "Edit" : "Add",
      targetId: this.isUpdateFlag ? this.currentSelectedTarget.targetId : 0,
      isActive: 1
    }

    this.reportsSerive.setRevenueTargetData(this.postTargetData)
      .subscribe(res => {
        this.isSubmitted = false
        if (res.isSuccess) {     
          if (res.response.statusCode == 4) {
            this.messageService.showSuccess("Target "+(this.isUpdateFlag? "Updated":"Added")+" Successfully");
            this.clearForm()
            this.closeConfirmModal();  
          }else if(res.response.statusCode == -1){
            this.messageService.showSuccess("Target already exist with this combination");
          }
                   
        } else {
          this.messageService.showSuccess(res.response.statusMessage);
        }

        this.getAllTargetsList();
      }, error => {
        this.isSubmitted = false
        this.messageService.showErrorMessage("Unable to update BU target, An error occur while updating  BU target.");
      })
  }


  updateActivationForTarget(data) {    
    if (data) {
      this.postTargetData = {
        clinicType: 12,
        expectedLeads:12,
        expectedRevenue: 12,
        fromDate: new Date(),
        toDate: new Date(),
        operation: "ActivateDeactivate",
        targetId: this.currentSelectedTarget.targetId,
        isActive: this.currentSelectedTarget.isActive
      }
  
      this.reportsSerive.setRevenueTargetData(this.postTargetData)
        .subscribe(res => {
          this.isSubmitted = false
          if (res.isSuccess) {     
            if (res.response.statusCode == 4) {
              this.messageService.showSuccess("Target Updated Successfully");
              this.clearForm()
              // this.closeConfirmModal();  
            }else if(res.response.statusCode == -1){
              this.messageService.showSuccess("Target already exist with this combination");
            }
                     
          } else {
            this.messageService.showSuccess(res.response.statusMessage);
          }
  
          this.getAllTargetsList();
        }, error => {
          this.isSubmitted = false
          this.messageService.showErrorMessage("Unable to update BU target, An error occur while updating  BU target.");
        })
    } else {
      this.currentSelectedTarget.isActive = this.currentSelectedTarget["isActive"]  == 1 ? 0 : 1;      
    }
  }

  askConfirmation(data,OpType) {
    data.isActive = data.isActive == 0 ? 1 : 0;
    this.currentSelectedTarget = data;
    let confirmMessage = data.isActive ? "activate" : "deactivate";
    this.messageService.confirmationMessage("you want to " + confirmMessage + " it");
  }

 
  closeConfirmModal() {
    this.confirmModalRef.hide();
  }

  bussinessUnitsData: any[] = [];
  DropDownBussinessUnits: any[] = [];
  getBussinessUnits() {
    this.commonService.getAllBussinessUnits()
      .subscribe((res: any) => {        
        if(res && res.response){
          this.bussinessUnitsData = res.response
          let sourceObj = [];          
          sourceObj.push({ label: 'All', value: "" })
          res.response.forEach(function (item) {                 
            sourceObj.push({ label: item.name , value: item.name })
          });
          this.DropDownBussinessUnits = sourceObj;
        }
      }, error => {        
        console.log(error)
      })
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.addForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  filterClinicType= ""
  filterActive= ""
  resetDataTablefilter(dt){  
    this.filterClinicType= ""
    this.filterActive= ""
    dt.reset();
  }

}
